import { FEDERATED_PHOTO_URL_PREFIXES } from '../constants/PhotoUploadConstants';

import type { PhotoProps } from '@zg-rentals/maintenance-utils';

export const isRentalManagerUploadedPhoto = (photo: PhotoProps): boolean =>
  FEDERATED_PHOTO_URL_PREFIXES.some((prefix) => photo.source?.startsWith(prefix) ?? false);

/** Returns the per-photo delete check for a feed listing's gallery, or undefined to keep the modal's default rules. */
export const getFeedPhotoDeleteCheck = ({
  isFeedGallery,
  isUploadAllowed,
  isPhotoEditBlocked,
}: {
  isFeedGallery: boolean;
  isUploadAllowed: boolean;
  isPhotoEditBlocked: boolean;
}): ((photo: PhotoProps) => boolean) | undefined =>
  isFeedGallery && isUploadAllowed && !isPhotoEditBlocked ? isRentalManagerUploadedPhoto : undefined;
